<svg width="100%" height="35" overflow="visible">
  <rect class="background-rect" width="100%" rx="7.3" ry="7.3" height="30" style="fill:var(--ion-background-percentagebar-color)" />
  @if (displayPercent) {
    <rect class="progress-rect" x="2" y="2" rx="6" ry="6" height="26" style="fill:var(--ion-color-active-percentagebar)"
      [style]="'width: calc(' + displayPercent + '% - 4px); transition: width 0.5s ease-in-out;'" />
  }
  <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" style="font-weight: 500"
      ngClass="secondary-color-contrast">
      {{ displayPercent | unitvalue: '%' }}
  </text>
  <ng-content></ng-content>
</svg>
